import { Box } from "@mui/material"


const EmptyItem = () => {

    return <Box
        width={32}
        height={32}
    >

    </Box>
}

export default EmptyItem